import { YUP_VALIDATIONS } from '@plug/helpers/yup-helpers';
import * as Yup from 'yup';

export const OrganizationRegisterAddressDataSchema = Yup.object().shape({
  cep: YUP_VALIDATIONS.cep,
  street: YUP_VALIDATIONS.street,
  number: YUP_VALIDATIONS.number,
  complement: YUP_VALIDATIONS.complement,
  neighbourhood: YUP_VALIDATIONS.neighbourhood,
  city: YUP_VALIDATIONS.city,
  state: YUP_VALIDATIONS.state,
});
